import { Dimension } from '@galaxy/billing';
import { Discount } from '../discount';

export class ContractDetailsSummary {
  constructor(
    public subscriptionId: string,
    public accountStatus: string,
    public dimension: Dimension,
    public subscriptionPrice: number,
    public subscriptionFrequency: string,
    public subscriptionCurrency: string,
    public contractNetD: number,
    public creditLimit: number,
    public contractSigned?: Date,
    public contractEnd?: Date,
    public contractActivated?: Date,
    public contractModified?: Date,
    public contractVerified?: Date,
    public onboardingFee?: number,
    public billingStrategy?: string,
    public discounts?: Discount[],
  ) {}
}
